import mergeWith from 'lodash/mergeWith';
import defaultLayout from '../config/default-layout';
import type { TreeGrid } from '../types';

export const mergeLayouts = (...args: (Partial<TreeGrid.Layout> | undefined)[]) => {
  return mergeWith({}, defaultLayout, ...args, (objValue: unknown, srcValue: unknown) => {
    if (Array.isArray(objValue) && Array.isArray(srcValue)) {
      return [...objValue, ...srcValue];
    }
  }) as TreeGrid.Layout;
};
